export const SORT_DIRECTION = { ascend: 'asc', descend: 'desc' };
